/**
 * Calendar utility functions for Google Calendar and ICS file generation
 */

const VENUE_ADDRESS = "7161, lieu dit la tournerie, 49270 Saint Laurent des Autels";
const EVENT_TITLE = "Séance Loulou Fitness 🏋️‍♂️";

/**
 * Format date to Google Calendar format (YYYYMMDDTHHmmssZ)
 */
function formatDateForGoogle(date) {
  return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
}

/**
 * Generate Google Calendar link
 * @param {Object} booking - Booking object with slot_start and duration_min
 * @returns {string} Google Calendar URL
 */
export function generateGoogleCalendarLink(booking) {
  const startDate = new Date(booking.slot_start);
  const endDate = new Date(startDate.getTime() + booking.duration_min * 60000);
  
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: EVENT_TITLE,
    dates: `${formatDateForGoogle(startDate)}/${formatDateForGoogle(endDate)}`,
    details: `Votre séance de ${booking.slot_family === 'coaching' ? 'coaching' : 'accès libre'} chez Loulou Fitness.`,
    location: VENUE_ADDRESS,
    sf: 'true',
    output: 'xml'
  });
  
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

/**
 * Generate ICS download URL (points to backend endpoint)
 * @param {string} bookingId - Booking ID
 * @returns {string} Backend ICS download URL
 */
export function generateICSDownloadUrl(bookingId) {
  const backendUrl = import.meta.env.VITE_BACKEND_URL || process.env.REACT_APP_BACKEND_URL || '';
  return `${backendUrl}/api/bookings/${bookingId}/calendar.ics`;
}

/**
 * Open Google Calendar in new tab
 */
export function openGoogleCalendar(booking) {
  const url = generateGoogleCalendarLink(booking);
  window.open(url, '_blank');
}

/**
 * Trigger ICS file download
 */
export function downloadICS(bookingId) {
  const url = generateICSDownloadUrl(bookingId);
  const link = document.createElement('a');
  link.href = url;
  link.download = `loulou-fitness-seance-${bookingId}.ics`;
  link.click();
}
